import React from 'react';
import { Helmet } from 'react-helmet';
import { makeStyles, Paper, CircularProgress } from '@material-ui/core';

import { MyAppBar, Messenger, MessageForm, AllUsers } from '../components';
import Sidebar from '../components/Sidebar';

import { auth } from '../utils/firebase';

const useStyles = makeStyles({
  app_container: {
    height: '100vh',
    width: '100vw',
    backgroundColor: '#c3c3cc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    height: '100vh',
    width: '100vw',
    maxHeight: '900px',
    maxWidth: '1400px',
    minHeight: '400px',
    minWidth: '800px',
    background: '#f7f7f7',
    display: 'grid',
    gridTemplateRows: 'auto 1fr 60px',
    gridTemplateColumns: '1fr 3fr',
    gridTemplateAreas: `'a c' 'u m' 'u f'`,
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 0,
  },
});

export default function HomeScreen() {
  const classes = useStyles();

  if (!auth.currentUser) {
    return <CircularProgress color='secondary' />;
  }

  return (
    <>
      <Helmet>
        <title>{auth.currentUser.displayName + ' - Chatty Messenger'}</title>
      </Helmet>
      <div className={classes.app_container}>
        <Paper className={classes.container} elevation={6}>
          <MyAppBar />
          <AllUsers />
          <Messenger />
          <MessageForm />
          <Sidebar />
        </Paper>
      </div>
    </>
  );
}
